import { ENDPOINTS } from "Config/endpoints";
import protectedApi from "Config/protectedApi";

export const getMetaPagesDetail = (req) => {
    const response = protectedApi.get(`${ENDPOINTS.metadetail}`, { params: req });
    return response;
}



export const postMetaPagesDetail = (reqBody) => {
    const response = protectedApi.post(`${ENDPOINTS.metadetail}`, reqBody);
    return response;
}

export const patchMetaPagesDetail = (reqBody) => {
    const response = protectedApi.patch(`${ENDPOINTS.metadetail}`, reqBody);
    return response;
}

export const deleteMetaPagesDetail = (reqBody) => {
    const response = protectedApi.delete(`${ENDPOINTS.metadetail}`, { data: reqBody });
    return response;
}
